import React from "react";

const LoadingSpinner = () => (
  <div className="overlay">
    <div className="spinner-container animated--fast-grow-in">
      <div className="spinner-box">
        <div className="loading-icon mb-2" />
        Cargando
      </div>
    </div>
  </div>
);

export default LoadingSpinner;
